'use client';

import { PostCard } from '@/components/ui/post-card';
import { cn } from '@/lib/utils';
import { HTMLAttributes } from 'react';

type ContentfulAsset = {
  fields?: {
    file?: { url?: string };
    title?: string;
    description?: string;
  };
};

export type InsightCardExperienceProps = {
  image?: ContentfulAsset | string | null;
  imageAlt?: string;
  tags?: string;
  title?: string;
  description?: string;
  date?: string;
  minRead?: number;
  ctaLabel?: string;
  ctaUrl?: string;
};

export const InsightCardExperience = ({
  image,
  imageAlt,
  tags,
  title,
  description,
  date,
  minRead,
  ctaLabel,
  ctaUrl,
  className,
}: InsightCardExperienceProps & HTMLAttributes<HTMLElement>) => {
  let imageUrl: string | undefined;
  if (typeof image === 'string') {
    imageUrl = image.startsWith('//') ? `https:${image}` : image;
  } else if (image?.fields?.file?.url) {
    imageUrl = image.fields.file.url.startsWith('//')
      ? `https:${image.fields.file.url}`
      : image.fields.file.url;
  }

  const alt =
    imageAlt ||
    (typeof image !== 'string' ? image?.fields?.description || image?.fields?.title : '') ||
    '';

  const parsedTags = tags
    ? tags
        .split(',')
        .map((t) => t.trim())
        .filter(Boolean)
    : undefined;

  return (
    <PostCard
      image={imageUrl}
      imageAlt={alt}
      tags={parsedTags}
      title={title}
      description={description}
      date={date}
      minRead={minRead}
      ctaLabel={ctaLabel}
      ctaUrl={ctaUrl}
      className={cn('text-left', className)}
    />
  );
};
